import { useLazyIndexedDBGraphqlQuery } from '@repo/services';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { getAllSalesGroups, type SalesGroupType } from '../queries/referencedConfigService';
import { setSalesGroups } from '../stores';

export const SALES_GROUP_ENDPOINT = '/v1/sales_groups';
export const SALES_GROUP_CACHE_KEY = 'sales-group';

export type SalesGroupListType = Array<SalesGroupType>;

export interface GetLeadAttributeOptionsType {
  salesGroups: SalesGroupType[];
}

export const useFetchSalesGroup = ({ skip = false }: { skip?: boolean } = {}) => {
  const dispatch = useDispatch();
  const [fetchSalesGroup, {
    data: salesGroupData,
    isLoading,
    error,
  }] = useLazyIndexedDBGraphqlQuery<GetLeadAttributeOptionsType>({
    cacheKey: SALES_GROUP_CACHE_KEY,
    document: getAllSalesGroups,
  });

  useEffect(() => {
    if (!skip && !isLoading && !salesGroupData) {
      fetchSalesGroup();
    }
  }, [fetchSalesGroup, skip, salesGroupData, isLoading]);

  useEffect(() => {
    if (salesGroupData?.salesGroups) {
      dispatch(setSalesGroups({ data: salesGroupData.salesGroups }));
    }
  }, [salesGroupData, dispatch]);

  return {
    fetchSalesGroup,
    salesGroupData: salesGroupData?.salesGroups as SalesGroupListType | null,
    isLoading,
    error,
  };
};
